import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "web/components/Button";
import * as moment from "moment";
import { useHistory } from "react-router-dom";
import { FORMAT } from "web/components/utils/dateOfBirthValidation";
import CurrencyFormat from "react-currency-format";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Tooltip from "@material-ui/core/Tooltip";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import infoicon from "web/assets/images/info-icon.png";
import AlertModal from 'web/components/AlertModal';
import SellArrowImage from "web/assets/images/right-arrow-sell.png";
import { offerInvWithdrawApi } from 'redux/actions/withDraw';
import { MobileViewContainer, Heading, AccordionContainer, } from "./MobileViewStyled";
import { fetchLanguageContentNew } from "redux/actions/language";

const MobileView = ({ offersInvData, displayNameHeader, callBackFun, type }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  const [alertType, setAlertType] = useState();
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();

  useEffect(() => {
    if (languageContentNew?.MyBids_Page) setPageLanguageContents(languageContentNew.MyBids_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  const [expanded, setExpanded] = React.useState(false);

  const withDrawFun = async (items) => {
    let data = {
      offerId: items?.offerId,
      authId: localStorage.getItem('authId')
    }
    let response = await dispatch(offerInvWithdrawApi(data, token));;
    if (response?.success) {
      setAlertType("acknowledge")
      setModalContent(response?.data?.msg);
      setModalLink('');
      toggleModal();
    } else {
      if (response?.message === "Unauthorized (Invalid token)") {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink('');
        toggleModal();
      }
    }
  }

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const tooltipAttach = (items) => {
    return (
      <Tooltip
        placement="bottom"
        leaveTouchDelay={10000}
        classes={{ popper: 'table-styleed-tooltip' }}
        arrow title={
          <>
            <ul>
              <li>
                <span className="col-6 text-bold">{pageLanguageContents?.Bids_Content[16]?.PalletType}</span>
                <span className="col-6">{items?.palletType || 'NA'}</span>
              </li>
              <li>
                <span className="col-6 text-bold">{pageLanguageContents?.Bids_Content[17]?.Grade}</span>
                <span className="col-6">{items?.grade ? items?.grade : 'NA'}</span>
              </li>
              <li>
                <span className="col-6 text-bold">{pageLanguageContents?.Bids_Content[18]?.Size}</span>
                <span className="col-6">{items?.size ? items?.size : 'NA'}</span>
              </li>
              <li>
                <span className="col-6 text-bold">{pageLanguageContents?.Bids_Content[19]?.Quantity}</span>
                <span className="col-6">{`${items?.qty} (${items?.lots} lot)`}</span>
              </li>
            </ul>
          </>
        }>
        <img style={{ marginTop: '2px' }} src={infoicon} className="info-icon" alt='infoicon' /></Tooltip>
    )
  }

  const dispalyFields = (items, index) => {
    return (
      <>
        <AccordionContainer>
          <Accordion
            expanded={expanded === "panel" + index}
            onChange={handleChange("panel" + index)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <div className="accordion-header">
                <h3>
                  <span>{items.postName}</span>
                  {tooltipAttach(items)}
                </h3>
                <p className={items.offerStatus?.toLowerCase()?.includes('accept') && "green-bid-status"}>
                  {items.offerStatus}
                </p>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className="accordion-detail-section">
                <div className="text-section">
                  <div>
                    <p className="label-text">Location</p>
                    <p>{items.location}</p>
                  </div>
                  <div>
                    <p className="label-text">Bid Price</p>
                    <p>{`$${items?.offerPrice.toFixed(2)}, ${items?.qty} Qty`}</p>
                  </div>
                  <div>
                    <p className="label-text">Requested Date</p>
                    <p>{moment(items.requestedDate).format(FORMAT)} </p>
                  </div>
                </div>
                <div className="action-wrapper">
                  {(items?.offerStatus?.toLowerCase()?.includes('placed') && type !== 'buyNowOffers') &&
                    <Button
                      type='app-green-button'
                      handleClick={() => withDrawFun(items)}>
                      {pageLanguageContents?.Bids_Content[21]?.Withdraw}
                    </Button>}
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        </AccordionContainer>
        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title={''}
          alertType={alertType}
          content={modalContent}
          link={modalLink}
          callBackAlert={(val) => {
            if (val === "acknowledge") {
              callBackFun()
            }
          }}
        />
      </>
    );
  };
  return (
    <MobileViewContainer>
      <Heading>
        <img src={SellArrowImage} alt="arrow-img" />
        <h2 style={{ color: '#00446e', fontSize: '21px' }}>{displayNameHeader}</h2>
      </Heading>
      {offersInvData?.map((items, index) => (
        <>{dispalyFields(items, index)}</>
      ))}
    </MobileViewContainer>
  );
};

export default MobileView;
